<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1 style="font-family:Calisto MT; font-size:18pt; letter-spacing:1px; padding-top:75px; padding-bottom:15px;">Dedication</h1>
<p style="text-align: center;">To Aurora, Margherita and Jacopo.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?d913bff2